/**
 * Custom HTML element that automatically adds icons to links within its content.
 * - Adds a file icon to links pointing to specific file types (e.g., .jpg, .pdf).
 * - Adds an external link icon to links pointing to external websites.
 *
 * @class LinkIcon
 * @extends HTMLElement
 *
 * @example
 * <custom-link-icon>
 *   <a href="https://external.com">External Site</a>
 *   <a href="document.pdf">PDF Document</a>
 * </custom-link-icon>
 */
class LinkIcon extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.links = this.querySelectorAll('a[href^="http"], a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"], a[href$=".pdf"], a[href$=".docx"], a[href$=".xlsx"], a[href$=".pptx"], a[href$=".txt"], a[href$=".zip"], a[href$=".xls"]');
        this.addIcon();
    }


    addIcon() {
        
        const externalLinkSvg = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="external-icon">
                                    <path d="M9.4001 1.6001H8.8001V2.8001H12.3526L6.5776 8.5751L6.1526 9.0001L7.0001 9.8476L7.4251 9.4226L13.2001 3.6476V7.2001H14.4001V1.6001H9.4001ZM2.2001 4.0001H1.6001V14.4001H12.0001V9.6001H10.8001V13.2001H2.8001V5.2001H6.4001V4.0001H2.2001Z" class="fill-primary-700"></path>
                                </svg>`;

        // Fallback for other links outside collapse-links
        this.links.forEach((el) => {
            const href = el.getAttribute('href');
            const isExternalLink = href && !href.includes(window.location.hostname);

            if (isExternalLink && !el.querySelector('.external-link')) {
                if (el.querySelector('img')) {
                    return;
                }
                el.classList.add('icon-link-flex');
                el.innerHTML += externalLinkSvg;

            }
        });
    }
}

window.customElements.define('custom-link-icon', LinkIcon);